

import React, { memo, useState, useRef, useMemo, useCallback } from 'react';
import { getCostValue } from '@shootsta/cost-parsing-utils';
import { ADDON_TYPE } from '@shootsta/common-domain-data';
import { Checkbox, Text, Link } from '../../../ui-kit';
import SocialIteration from './SocialIteration';

import EditCost from '../../Addons/components/Expandable/common/EditCost';
import { canUpdateOutput } from '../../../common/utils';
import { ABOUT_ADDON_OPTIONS } from '../../../common/constants';
import { AboutAddonModal } from '../../Addons';

import '../styles/_social-iterations.scss';

const SMALL_BREAKPOINT = 639;
const SMALL_BREAKPOINT_MODAL = 500;































function handleIterationVisibleChange({
  areIterationsVisible,
  createNewOutput,
  setInitialOutput,
  setIterationsVisibility,
  outputs
}) {
  if (!areIterationsVisible && outputs.length === 1) {
    createNewOutput();
  }

  if (areIterationsVisible) {
    setInitialOutput(outputs.slice(0, 1));
  }

  setIterationsVisibility(!areIterationsVisible);
}

function getIterationsTotalCost(outputs) {
  return outputs.
  filter((output) => !output.isMaster).
  reduce((accumulator, output) => getCostValue(output, 'outputCost') + accumulator, 0);
}

function getIsMobile({ isEditingMode, width }) {
  if (isEditingMode) {
    return width <= SMALL_BREAKPOINT_MODAL;
  }

  return width <= SMALL_BREAKPOINT;
}

function onDeleteOutput({
  index,
  setIterationsVisibility,
  additionalOutputs,
  deleteOutput





}) {
  if (additionalOutputs.length === 1) {
    setIterationsVisibility(false);
  }

  deleteOutput(index);
}

function SocialIterations(
{
  assets,
  outputCost,
  outputs,
  hasUpdatePermission,
  canUpdateVideo,
  onSave,
  handleNotesChange,
  onChangeAddon,
  setInitialOutput,
  createNewOutput,
  deleteOutput,
  updateOutputName,
  onChangeCost,
  getCurrencySymbol,
  getCurrencyIcon,
  editingMode,
  showAboutInfo,
  projectType = ''
})
{
  const [
  areIterationsVisible,
  setIterationsVisibility] =
  useState(Boolean(outputs.length > 1));

  const [showAboutModal, setShowAboutModal] = useState(false);
  const isPodcast = projectType === 'PODCAST';

  const onToggleAboutModal = useCallback(
    () => setShowAboutModal(!showAboutModal),
    [showAboutModal]
  );

  const iterationsBlockRef = useRef();

  const iterationsWidth = useMemo(() =>
  iterationsBlockRef.current?.offsetWidth || 0,
  [iterationsBlockRef.current?.offsetWidth]);

  const isMobile = useMemo(() =>
  getIsMobile({ width: iterationsWidth, isEditingMode: editingMode }),
  [iterationsWidth, editingMode]);

  const masterOutputIndex = outputs.findIndex((output) => output.isMaster);
  const masterOutput = outputs[masterOutputIndex];

  if (!masterOutput) {return null;}

  const canUpdateMaster = canUpdateOutput({
    hasUpdatePermission,
    output: masterOutput,
    editingMode
  });
  const additionalOutputs = [...outputs];

  additionalOutputs.splice(masterOutputIndex, 1);

  const currencyIcon = getCurrencyIcon ? getCurrencyIcon() : '';

  return (
    <div className="social-iterations" ref={iterationsBlockRef}>
      <div className="social-iterations__main">
        <Checkbox
          prefixIcon="square"
          checked={areIterationsVisible}
          disabled={!canUpdateMaster}
          onChange={() => handleIterationVisibleChange({
            areIterationsVisible,
            createNewOutput,
            setInitialOutput,
            setIterationsVisibility,
            outputs
          })}>

          <Text heading5>Social Iterations</Text>
        </Checkbox>

        {!editingMode && <Text className="social-iterations__cost" heading5>{`${currencyIcon}${outputCost} ea.`}</Text>}

        {editingMode && areIterationsVisible &&
        <EditCost
          cost={getIterationsTotalCost(outputs)}
          getCurrencySymbol={getCurrencySymbol}
          getCurrencyIcon={getCurrencyIcon}
          disabled />}



        {
        showAboutInfo &&
        <div className="social-iterations__about">
              <Link onClick={onToggleAboutModal}>
                {ABOUT_ADDON_OPTIONS.ADDITIONAL_OUTPUT.LINK_TEXT}
              </Link>
            </div>}


      </div>

      <Text className="social-iterations__subtitle">Pending approval of master iteration</Text>

      <div className="social-iterations__children">
        {areIterationsVisible &&
        <>
            {additionalOutputs.map((output, index) => {
            const key = `iteration-${output.outputId}-${index}`;
            const isLastOutput = index === additionalOutputs.length - 1;

            return (
              <SocialIteration
                {...output}
                isPodcast={isPodcast}
                output={output}
                outputs={outputs}
                outputIndex={index}
                assets={assets}
                isMobile={isMobile}
                onNotesChange={handleNotesChange}
                onBlurField={onSave}
                onChangeAddon={onChangeAddon(output.outputId)}
                createNewOutput={createNewOutput}
                deleteOutput={() => onDeleteOutput({
                  index, setIterationsVisibility, additionalOutputs, deleteOutput
                })}
                updateOutputName={updateOutputName}
                canUpdateVideo={canUpdateVideo}
                canUpdateMaster={canUpdateMaster}
                isLastOutput={isLastOutput}
                getCurrencySymbol={getCurrencySymbol}
                getCurrencyIcon={getCurrencyIcon}
                outputCost={outputCost}
                onChangeCost={onChangeCost(output.outputId)}
                editingMode={hasUpdatePermission && editingMode}
                key={key} />);


          })}
          </>}

      </div>

      <AboutAddonModal
        addonType={ADDON_TYPE.ADDITIONAL_OUTPUT}
        visible={showAboutModal}
        onClose={onToggleAboutModal} />

    </div>);

}

SocialIterations.defaultProps = {
  editingMode: false
};

export default memo(SocialIterations);